import Hotjar from "@hotjar/browser";
import * as Sentry from "@sentry/browser";
import Bluebird from "bluebird";
import { StudioConfig } from "models/Config";
import React from "react";
import { render as renderDOM } from "react-dom";

import TagManager from "react-gtm-module";
import ReactGA from "react-ga4";

import { createStore } from "redux/createStore";
import { RootContainer } from "./containers/RootContainer";

import "./styles/editor.scss";
import "./styles/style.scss";

declare global {
    interface Window {
        xaStudioConfig?: StudioConfig;
        grecaptcha?: any
    }
}

const { store, history } = createStore();
const MOUNT_NODE = document.getElementById("root");

//
// This is loaded
let config = window.xaStudioConfig;
let compiledConfig: StudioConfig;

try {
    compiledConfig = __CONFIG__;
} catch (e) {
    console.info(`Unable to parse config`, e);
    console.log(__CONFIG__);
}

// Merge the configs
if (compiledConfig) {
    window.xaStudioConfig = {
        ...window.xaStudioConfig,
        ...compiledConfig,
    }
    config = {
        ...config,
        ...compiledConfig
    }
}

console.log(`${__RELEASE__}, latest commit ${__COMMITHASH__}`);

Bluebird.config({ cancellation: true });

if (!!window.xaStudioConfig.googleAnalyticsKey) {
    ReactGA.initialize(window.xaStudioConfig.googleAnalyticsKey);
}

if (!!window.xaStudioConfig.googleTagManagerId) {
    const tagManagerArgs = {
        gtmId: window.xaStudioConfig.googleTagManagerId
    }

    TagManager.initialize(tagManagerArgs);
}

if (!!window.xaStudioConfig.sentryKey) {
    Sentry.init({ dsn: window.xaStudioConfig.sentryKey, release: __RELEASE__ });
}

if (!!window.xaStudioConfig.hotjarSiteId) {
    const hotjarSiteId = Number(window.xaStudioConfig.hotjarSiteId);
    const hotjarVersion = 6;
    Hotjar.init(hotjarSiteId, hotjarVersion);
}

renderDOM(<RootContainer config={config} store={store} history={history} />, MOUNT_NODE);
